export default __webpack_public_path__ + "static/media/Ballroll_00364.ae6a2aa6.png";